import { NavLink } from 'react-router-dom';
import { BellIcon } from '@kilat/ui';

import { useI18n } from '../lib/use-i18n.js';
import { useAgentInbox } from '../lib/push/agent-push.js';

/**
 * Header bell for the agent app: unread count of `users/{uid}/inbox`, linking
 * to /inbox. Slotted INTO the existing sticky header row (beside the locale
 * switcher) — not a new floating corner. The badge fails quietly; the /inbox
 * screen owns the visible error state. Live listener, so a push that also
 * lands in the inbox updates the count at once.
 */
export function InboxBell() {
  const t = useI18n();
  const { messages } = useAgentInbox(() => undefined);
  const unread = messages.filter((m) => !m.readAt).length;
  const label =
    unread > 0 ? t.t('agent.inbox.bellAriaUnread', { count: unread }) : t.t('agent.inbox.bellAria');

  return (
    <NavLink
      to="/inbox"
      aria-label={label}
      style={({ isActive }) => ({
        position: 'relative',
        minWidth: 'var(--touch-target)',
        minHeight: 'var(--touch-target)',
        width: 'var(--touch-target)',
        height: 'var(--touch-target)',
        borderRadius: 'var(--radius-pill)',
        border: '1px solid var(--color-border-strong)',
        background: isActive ? 'var(--color-primary-soft)' : 'var(--color-surface)',
        color: 'var(--color-on-surface)',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        textDecoration: 'none',
        flexShrink: 0,
      })}
    >
      <BellIcon size={18} />
      {unread > 0 ? (
        <span
          aria-hidden
          style={{
            position: 'absolute',
            top: 'var(--space-1)',
            right: 'var(--space-1)',
            minWidth: '1rem',
            height: '1rem',
            padding: '0 var(--space-1)',
            borderRadius: 'var(--radius-pill)',
            background: 'var(--color-primary)',
            color: 'var(--color-primary-fg)',
            fontSize: '0.625rem',
            fontWeight: 700,
            lineHeight: '1rem',
            textAlign: 'center',
            fontVariantNumeric: 'tabular-nums',
          }}
        >
          {unread > 9 ? '9+' : unread}
        </span>
      ) : null}
    </NavLink>
  );
}
